import { CustomFieldRenderer } from './CustomFieldRenderer'
import type { CustomFieldDefinitionDocument, CustomFieldValueDocument } from './types'

interface CustomFieldInlineProps {
  fields: Array<CustomFieldDefinitionDocument>
  valueMap: Map<string, CustomFieldValueDocument>
  taskId: string
  readOnly?: boolean
  layout?: 'horizontal' | 'sidebar'
}

export function CustomFieldInline({
  fields,
  valueMap,
  taskId,
  readOnly = false,
  layout = 'horizontal',
}: CustomFieldInlineProps) {
  if (fields.length === 0) return null

  return (
    <>
      {fields.map((field) => (
        <CustomFieldRenderer
          key={field.id}
          definition={field}
          value={valueMap.get(field.id)}
          taskId={taskId}
          readOnly={readOnly}
          variant="metadata"
          layout={layout}
        />
      ))}
    </>
  )
}
